var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSolo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4",
    "data-name": "Group 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 175.925,
    height: 241.33,
    viewBox: "0 0 175.925 241.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M87.132,87.132A87.23,87.23,0,0,0,0,0V49.209A37.964,37.964,0,0,1,37.923,87.132,37.964,37.964,0,0,1,0,125.055v49.209A87.23,87.23,0,0,0,87.132,87.132",
    fill: "#100ea0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M88.493,154.2A87.23,87.23,0,0,0,1.361,241.33H50.57a37.923,37.923,0,1,1,75.846,0h49.209A87.23,87.23,0,0,0,88.493,154.2",
    fill: "#100ea0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M175.925,49.21V0a87.132,87.132,0,1,0,0,174.263V125.055a37.923,37.923,0,1,1,0-75.845",
    fill: "#100ea0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSolo);
export default __webpack_public_path__ + "static/media/logo-solo.a73581a62f10017a17df90fa2a9f39c2.svg";
export { ForwardRef as ReactComponent };